import { EMITTER_TYPES, type TEmitterType } from '@semios/app-platform-values-helpers-and-types'
import type {
  TProperty,
  TValidIrrigationSchedulerEmitterType,
  TValidIrrigationSchedulerZoneEmitter,
  TValidIrrigationSchedulerZoneEmitterId,
} from 'stores/fieldAssetStore/helperTypes'

const isValidEmitterType = (
  emitterType: TEmitterType,
): emitterType is TValidIrrigationSchedulerEmitterType => {
  return EMITTER_TYPES.includes(emitterType) && emitterType.startsWith('emitter-')
}

// this function filters out the so-called "emitterTypes" that are not prefixed with 'emitter-'
export const getValidIrrigationSchedulerEmitters = (
  propertyEmitters: TProperty['irrigationZoneEmitters'],
): Record<TValidIrrigationSchedulerZoneEmitterId, TValidIrrigationSchedulerZoneEmitter> => {
  if (!propertyEmitters) return {}

  return Object.fromEntries(
    Object.entries(propertyEmitters).filter(([, { emitterType }]) => isValidEmitterType(emitterType)),
  ) as Record<TValidIrrigationSchedulerZoneEmitterId, TValidIrrigationSchedulerZoneEmitter>
}
